import { takeLatest, put, call } from "redux-saga/effects";
import { post } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

import {
  FETCH_TRIPMASTER_REQUEST,
  FETCH_TRIPMASTER_SUCCESS,
  FETCH_TRIPMASTER_FAILURE,
  SAVE_TRIPMASTER_REQUEST,
  SAVE_TRIPMASTER_SUCCESS,
  SAVE_TRIPMASTER_FAILURE,
  DELETE_TRIPMASTER_REQUEST,
  DELETE_TRIPMASTER_SUCCESS,
  DELETE_TRIPMASTER_FAILURE,
} from "./actionTypes";

function* fetchTripmasterSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_GET_REIMBURSEMENT_TRIPMASTER,
      action.payload
    );

    yield put({ type: FETCH_TRIPMASTER_SUCCESS, payload: response });
  } catch (error) {
    console.error("Fetch Tripmaster Error:", error);
    yield put({
      type: FETCH_TRIPMASTER_FAILURE,
      payload: error.message,
    });
  }
}

function* saveTripmasterSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_REIMBURSEMENT_TRIPMASTER,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save tripmaster!");
    }

    yield put({ type: SAVE_TRIPMASTER_SUCCESS, payload: response });
    Swal.fire("Success", response.message, "success");
  } catch (error) {
    console.error("Save Tripmaster Error:", error);
    yield put({ type: SAVE_TRIPMASTER_FAILURE, payload: error.message });
    Swal.fire("Error", error.message, "error");
  }
}

function* deleteTripmasterSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_DELETE_REIMBURSEMENT_TRIPMASTER,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to delete tripmaster!");
    }

    yield put({ type: DELETE_TRIPMASTER_SUCCESS, payload: response });
    Swal.fire("Deleted!", response.message, "success");
  } catch (error) {
    yield put({ type: DELETE_TRIPMASTER_FAILURE, payload: error.message });
    Swal.fire("Error", error.message, "error");
  }
}

export default function* tripmasterSaga() {
  yield takeLatest(FETCH_TRIPMASTER_REQUEST, fetchTripmasterSaga);
  yield takeLatest(SAVE_TRIPMASTER_REQUEST, saveTripmasterSaga);
  yield takeLatest(DELETE_TRIPMASTER_REQUEST, deleteTripmasterSaga);
}
